<!-- Hero Section -->
<div class="softwaredev-section-bg">
  <section class="softwaredev-section container py-5">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <div class="col-lg-5">
          <h1 class="softwaredev-heading mb-3">
            Tech Geek Ed. 2
          </h1>
          <!-- <h3 class="softwaredev-subheading2 mb-4">
            Discover the fresh stories of Kalpita Technologies.
          </h3> -->
          <div class="mb-5 contact-btn">
            <!-- <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
              Case Studies
            </button> -->
            <!-- <button class="btn hire-btn hire" (click)="exploreOurSolutions()">
              Explore Our Solutions
            </button> -->
          </div>
        </div>

        <div class="col-lg-7 text-center">
          <img src="../../../../assets/resources/techgeek/tech-geek-2-bannerimg.gif" alt="Tech Geek Edition2"
            class="img-fluid hero-image">
        </div>
      </div>
    </div>
  </section>
</div>
<!-- TL;DR Section with Image Icon -->
<section class="takeaways-section py-5">
  <div class="container">
    <h2 class="section-title text-center">TL;DR</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          Tech Geek Ed. 2 explores emerging technology trends, innovative applications, and real-world use cases shaping
          the digital ecosystem.
        </p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          The edition highlights secure peer-to-peer file sharing, AI-powered productivity tools, and smart consumer
          applications.
        </p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          Breakthroughs in assistive technologies and augmented reality navigation show how tech is improving
          accessibility and daily life.
        </p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          Advances in AI emotion detection reveal the growing role of artificial intelligence in human-centric
          interactions.
        </p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          A detailed AWS vs Azure vs Google Cloud comparison provides insights into the cloud computing market and
          performance trends.
        </p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          Overall, the edition positions Tech Geek as a forward-looking technology knowledge hub for professionals,
          developers, and digital leaders.
        </p>
      </div>
    </div>
  </div>
</section>
<!-- Key Takeaways Section with Image Icon -->
<section class="takeaways-section pt-0 pb-5">
  <div class="container">
    <h2 class="section-title text-center">Key Takeaways</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>Tech Geek Community & Vision:</strong> Tech Geek acts as a collaborative platform helping the global
          tech community stay informed about innovations, trends, and digital transformation.
        </p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>Secure Peer-to-Peer File Sharing:</strong> P2P technologies emphasize data ownership, privacy, and
          cybersecurity, providing safer alternatives in a threat-heavy digital world.
        </p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>Smart Consumer & AI Apps:</strong> Tools like Supercook and BLACKBOX AI demonstrate how artificial
          intelligence improves productivity, creativity, and everyday problem-solving.
        </p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>Assistive & Accessibility Innovations:</strong> Subtitle-enabled smart glasses show how assistive
          technology can dramatically enhance accessibility for the deaf community.
        </p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>AR-Based Navigation with Google Maps VPS:</strong> Google’s Visual Positioning System uses AR to
          provide highly accurate, intuitive real-world navigation.
        </p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>AI Emotion & Feeling Detection:</strong> Real-time emotion recognition is reshaping healthcare, mental
          wellness, marketing, and customer experience.
        </p>
      </div>
    </div>
    <button class="btn case-study-btn" (click)="openModal()">
      Access Your Copy
    </button>
  </div>
</section>
<!-- Relevant Article -->
<app-relevant-techgeek></app-relevant-techgeek>

<!-- MODAL POPUP -->
<div class="modal-overlay" *ngIf="isModalOpen">
  <div class="modal-content-box">
    <button class="close-btn" (click)="closeModal()">&times;</button>

    <div class="modal-header" *ngIf="!submitSuccess">
      <h3>Access Your TechGeek Copy</h3>
      <p>Fill in your details to receive the Tech Geek Edition 2.</p>
    </div>

    <div *ngIf="submitSuccess" class="success-message text-center">
      <i class="ri-checkbox-circle-fill" style="color: #28a745; font-size: 3rem;"></i>
      <h4>Thank you!</h4>
      <p>Check your email for the download link.</p>
      <small style="color: #666;">Please check your spam folder if you don't see it.</small>
    </div>

    <form [formGroup]="downloadForm" (ngSubmit)="onSubmit()" *ngIf="!submitSuccess">
      <div class="form-group">
        <label>Full Name</label>
        <input type="text" formControlName="name" class="form-control" placeholder="Name">
        <div class="error-msg" *ngIf="downloadForm.get('name')?.touched && downloadForm.get('name')?.errors">

          <span *ngIf="downloadForm.get('name')?.errors?.['required']">
            Name is required
          </span>

          <span *ngIf="downloadForm.get('name')?.errors?.['pattern']">
            Name should contain only letters
          </span>

        </div>
      </div>

      <div class="form-group">
        <label>Email Address</label>
        <input type="email" formControlName="email" class="form-control" placeholder="Email">
        <div class="error-msg" *ngIf="downloadForm.get('email')?.touched && downloadForm.get('email')?.errors">

          <span *ngIf="downloadForm.get('email')?.errors?.['required']">
            Email is required
          </span>

          <span *ngIf="downloadForm.get('email')?.errors?.['pattern']">
            Enter a valid email address
          </span>

        </div>
      </div>

      <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

      <div class="modal-footer">
        <button type="submit" class="submit-btn" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Processing...' : 'Download Now' }}
        </button>
      </div>
    </form>
  </div>
</div>